import React from 'react';
import Carousel from '../carousel/Carousel';
import Item from './Item';
import styles from './MainSlider.module.scss';
import Page from './Page';
import Pagination from './Pagination';

// eslint-disable-next-line react/display-name
const MainSlider = React.forwardRef(({ children, ...rest }, ref) => {
  return (
    <div ref={ref} className={styles.root}>
      <Carousel pagination page={<Page />} paginationContainer={<Pagination />} {...rest}>
        {children}
      </Carousel>
    </div>
  );
});

MainSlider.Item = Item;

export default MainSlider;
